import script from "./CartHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CartHeader.vue?vue&type=script&setup=true&lang=js"

import "./CartHeader.vue?vue&type=style&index=0&id=6b43806c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b43806c"]])

export default __exports__